import { Alert, Box, Button, Spinner } from '@amzn/awsui-components-react';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { get } from 'lodash';
import OrbitPageLayout from './OrbitPageLayout';
import { RESOURCE, isPageAccessible } from '../../auth/constants/rbac_constants';
import { listPermissionsAction } from '../../../common/components/with_page/redux/reducer';

// Access gate for the Orbit compliance-season pages. Mirrors how Page gates the
// standard pages (fetch permissions, then check PAGE_CAN_ACCESS on the PageId),
// but keeps OrbitPageLayout as the layout instead of Page's AppLayout+NavBar shell.
class OrbitPageGate extends React.Component {
  constructor(props) {
    super(props);
    this.state = { requested: false };
    this.loadPermissions = this.loadPermissions.bind(this);
  }

  componentDidMount() {
    const { permissions } = this.props;
    if (!permissions) {
      this.loadPermissions();
    }
  }

  loadPermissions() {
    const { listPermissionsBegin } = this.props;
    this.setState({ requested: true });
    listPermissionsBegin();
  }

  isAccessible() {
    const { permissions } = this.props;
    return isPageAccessible(permissions, RESOURCE.PAGE_STUDY_SUMMARY);
  }

  render() {
    const {
      children,
      breadCrumbItems,
      fullBleedContent,
      permissions,
      permissionsFetching,
    } = this.props;
    const { requested } = this.state;

    // The permissions FAILURE carries no payload, so a settled request without data is the failure signal.
    if (!permissions && requested && !permissionsFetching) {
      return (
        <OrbitPageLayout breadCrumbItems={breadCrumbItems}>
          <Alert
            type="error"
            header="Could not load your permissions"
            action={<Button onClick={this.loadPermissions}>Retry</Button>}
          >
            Refresh the page or retry to load this page.
          </Alert>
        </OrbitPageLayout>
      );
    }

    if (!permissions) {
      return (
        <OrbitPageLayout breadCrumbItems={breadCrumbItems}>
          <Box textAlign="center" padding="xxl">
            <Spinner size="large" />
          </Box>
        </OrbitPageLayout>
      );
    }

    if (!this.isAccessible()) {
      return (
        <OrbitPageLayout breadCrumbItems={breadCrumbItems}>
          <Alert type="error" header="Not authorized">
            You are not authorized to access this page.
          </Alert>
        </OrbitPageLayout>
      );
    }

    return (
      <OrbitPageLayout breadCrumbItems={breadCrumbItems} fullBleedContent={fullBleedContent}>
        {children}
      </OrbitPageLayout>
    );
  }
}

OrbitPageGate.propTypes = {
  children: PropTypes.node.isRequired,
  breadCrumbItems: PropTypes.array,
  fullBleedContent: PropTypes.bool,
  permissions: PropTypes.array,
  permissionsFetching: PropTypes.bool,
  listPermissionsBegin: PropTypes.func.isRequired,
};

OrbitPageGate.defaultProps = {
  breadCrumbItems: [],
  fullBleedContent: false,
  permissions: null,
  permissionsFetching: false,
};

const mapStateToProps = state => ({
  permissions: get(state, 'appMetaData.permissions.data', null),
  permissionsFetching: get(state, 'appMetaData.permissions.isFetching', false),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ listPermissionsBegin: listPermissionsAction.BEGIN }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OrbitPageGate);
